import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'

import stepCardStyles from './css/stepCardStyles'

const StepCard = ({ stepNumber, hideSteps, children }) => {
  const classes = stepCardStyles()

  return (
    <div className={classes.root}>
      {!hideSteps && (
        <div className={classes.stepContainer}>
          <Typography variant="h6" align="center" color="inherit" className={classes.boldFont}>
            Paso {stepNumber}
          </Typography>
        </div>
      )}
      <div className={hideSteps ? classes.childrenContainerNoSteps : classes.childrenContainer}>
        {children}
      </div>
    </div>
  )
}

StepCard.propTypes = {
  stepNumber: PropTypes.number,
  hideSteps: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

StepCard.defaultProps = {
  stepNumber: 0,
  hideSteps: false,
}

export default StepCard
